import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import FieldInput from '../../components/FieldInput';
import FieldCheckbox from '../../components/FieldCheckbox';
import FieldFileUpload from '../../components/FieldFileUpload';
import Button from '../../components/Button';
import FieldDatepicker from '../../components/FieldDatepicker';
import FieldSelect from '../../components/FieldSelect';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step13View = ({
                      values,
                      loadOptions: {
                        immigrant,
                        childrenOpts
                      },
                      isValid
                    }) => {
  return (
    <Form className={styles.formContainer}>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id='step13.form.title'
          />
        </div>
      </div>
      <div>
        <div className={`${styles.contentBlock} ${styles.text}`}>
          <FormattedMessage
            id='step13.form.receiveExemption.title'
            defaultMessage='I would like to receive a tax exemption or credit for the following reasons (only choose what is relevant to you)'
          />
        </div>
        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'israelResident'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.residentOfIsrael.label'
                  defaultMessage='I am a resident of Israel'
                />
              </div>
            )}
          />
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'disabled'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isBlind.label'
                  defaultMessage={'I\'m 100% permanently blind'}
                />
              </div>
            )}
            containerStyles={values.disabled && styles.input}
          />
          {values.disabled && (
            <>
              <FieldFileUpload
                accept=".jpg, .jpeg, .png, .bmp"
                fieldId={'uploadBlindCertificate'}
                label={(
                  <FormattedMessage
                    id='step13.form.isBlind.uploadBlindCertificate.label'
                    defaultMessage='Approval from the Ministry of Defense / Finance / Assessing Officer / Blind Certificate issued after 1/1/94'
                  />
                )}
                cameraLabel={(
                  <FormattedMessage
                    id='common.form.uploadId.note'
                    defaultMessage='Take a photo or upload a file'
                  />
                )}
                containerStyles={styles.input}
              />
              <div className={styles.text}>
                <FormattedMessage
                  id='common.form.upload.unableToAttachFile.label'
                  defaultMessage='If you are unable to attach this file now, it will be possible to send it to us later'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'specialResidentLocation'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isPermanentResident.label'
                  defaultMessage={'I am a permanent resident of a qualifying community. My first-degree family and I live in the locality and I do not have another "life center"'}
                />
              </div>
            )}
            containerStyles={values.specialResidentLocation && styles.input}
          />
          {values.specialResidentLocation && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isPermanentResident.text'
                  defaultMessage='Eligible locality - a locality to which section 11 of the Income Tax Ordinance or section 11 of the NIS Law applies, as the case may be.'
                />
              </div>
              <FieldDatepicker
                fieldId='specialResidentLocationFromDate'
                label={(
                  <FormattedMessage
                    id='step13.form.isPermanentResident.from.label'
                    defaultMessage='From date'
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldInput
                fieldId='specialResidentLocationName'
                loadOptions={immigrant}
                label={(
                  <FormattedMessage
                    id='step13.form.isPermanentResident.settlement.label'
                    defaultMessage={'The settlement'}
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldFileUpload
                accept=".jpg, .jpeg, .png, .bmp"
                fieldId={'uploadApprovalOfAuthority'}
                label={(
                  <FormattedMessage
                    id='step13.form.isPermanentResident.uploadApprovalOfAuthority.label'
                    defaultMessage='Approval of the Authority on Form 1312A'
                  />
                )}
                cameraLabel={(
                  <FormattedMessage
                    id='common.form.uploadId.note'
                    defaultMessage='Take a photo or upload a file'
                  />
                )}
                containerStyles={styles.input}
              />
              <div className={styles.text}>
                <FormattedMessage
                  id='common.form.upload.unableToAttachFile.label'
                  defaultMessage='If you are unable to attach this file now, it will be possible to send it to us later'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'newResident'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isNewImmigrant.label'
                  defaultMessage={'I am a new immigrant / returning resident'}
                />
              </div>
            )}
            containerStyles={values.newResident && styles.input}
          />
          {values.newResident && (
            <>
              <FieldSelect
                fieldId='newResidentType'
                loadOptions={immigrant}
                label={(
                  <FormattedMessage
                    id='step13.form.isNewImmigrant.immigrantType.label'
                    defaultMessage={'Select'}
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldDatepicker
                fieldId='newResidentFromDate'
                label={(
                  <FormattedMessage
                    id='step13.form.isNewImmigrant.from.label'
                    defaultMessage='From date'
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldDatepicker
                fieldId='newResidentNoIncomeToDate'
                label={(
                  <FormattedMessage
                    id='step13.form.isNewImmigrant.until.label'
                    defaultMessage='I have not had income in Israel from the beginning of the current tax year until date'
                  />
                )}
                containerStyles={styles.input}
              />
              {
                values.newResidentType.value === 1 && (
                  <FieldFileUpload
                    accept=".jpg, .jpeg, .png, .bmp"
                    fieldId={'uploadImmigrationCertificate'}
                    label={(
                      <FormattedMessage
                        id='step13.form.isNewImmigrant.uploadImmigrationCertificate.label'
                        defaultMessage='New immigrant - please attach a photocopy of immigration certificate'
                      />
                    )}
                    cameraLabel={(
                      <FormattedMessage
                        id='common.form.uploadId.note'
                        defaultMessage='Take a photo or upload a file'
                      />
                    )}
                    containerStyles={styles.input}
                  />
                )
              }
              {
                values.newResidentType.value === 2 && (
                  <FieldFileUpload
                    accept=".jpg, .jpeg, .png, .bmp"
                    fieldId={'uploadReturningCertificate'}
                    label={(
                      <FormattedMessage
                        id='step13.form.isNewImmigrant.uploadReturningCertificate.label'
                        defaultMessage='Returning resident - Please attach a returning resident certificate'
                      />
                    )}
                    cameraLabel={(
                      <FormattedMessage
                        id='common.form.uploadId.note'
                        defaultMessage='Take a photo or upload a file'
                      />
                    )}
                    containerStyles={styles.input}
                  />
                )
              }
              <div className={styles.text}>
                <FormattedMessage
                  id='common.form.upload.unableToAttachFile.label'
                  defaultMessage='If you are unable to attach this file now, it will be possible to send it to us later'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'spouseHasNoIncome'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.spouseHasNoIncome.label'
                  defaultMessage={'In respect of my spouse who lives with me and has no income in the tax year'}
                />
              </div>
            )}
            containerStyles={values.spouseHasNoIncome && styles.input}
          />
          {values.spouseHasNoIncome && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.spouseHasNoIncome.text'
                  defaultMessage='The age of the spouse has reached or the spouse only with the employee according to is disabled or blind / retired or is. Section 9 (5) of the Ordinance'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'singleParentNoCustody'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isSingleParent.label'
                  defaultMessage={'I am a parent in a single parent family but live separately'}
                />
              </div>
            )}
            containerStyles={values.singleParentNoCustody && styles.input}
          />
          {values.singleParentNoCustody && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isSingleParent.text.1'
                  defaultMessage='Will be filled only by a parent who lives separately and applies for credit points for his children, who are in his possession and for whom he receives a child allowance from the National Insurance Institute and does not run another / joint household with an individual,'
                />
              </div>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isSingleParent.text.2'
                  defaultMessage='A parent in a single-parent family is one of the following: single (divorced, widowed, separated (according to P.S. only)'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'forChildren'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isForChildren.label'
                  defaultMessage={'For my children I held'}
                />
              </div>
            )}
            containerStyles={values.forChildren && styles.input}
          />
          {values.forChildren && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForChildren.text.1'
                  defaultMessage='You can only mark if one of the conditions is met:'
                />
              </div>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForChildren.text.2'
                  defaultMessage='The following are not married and you reported children who are in your possession, for which you receive a child allowance from the National Insurance Institute.'
                />
              </div>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForChildren.text.3'
                  defaultMessage={'You\'re a married woman.'}
                />
              </div>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForChildren.text.4'
                  defaultMessage='You marked field 9 - I am a single parent of my children.'
                />
              </div>
              <FieldSelect
                fieldId='forChildrenBornCount'
                loadOptions={childrenOpts}
                label={(
                  <FormattedMessage
                    id='step13.form.isForChildren.childrenBorn.label'
                    defaultMessage={'Number of children born in the current tax year'}
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldSelect
                fieldId='forChildrenUpTo5Count'
                loadOptions={childrenOpts}
                label={(
                  <FormattedMessage
                    id='step13.form.isForChildren.childrenUpTo5yo.label'
                    defaultMessage={'The number of children who will be one to five years old this year'}
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldSelect
                fieldId='forChildrenUpTo17Count'
                loadOptions={childrenOpts}
                label={(
                  <FormattedMessage
                    id='step13.form.isForChildren.childrenUpTo17yo.label'
                    defaultMessage={'The number of children who will turn 6 to 17 this year'}
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldSelect
                fieldId='forChildrenUpTo18Count'
                loadOptions={childrenOpts}
                label={(
                  <FormattedMessage
                    id='step13.form.isForChildren.childrenTurn18yo.label'
                    defaultMessage={'The number of children who will turn 18 this year'}
                  />
                )}
                containerStyles={styles.input}
              />
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'forToddlers'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isForToddlers.label'
                  defaultMessage={'For the children of toddlers'}
                />
              </div>
            )}
            containerStyles={values.forToddlers && styles.input}
          />
          {values.forToddlers && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForToddlers.text.1'
                  defaultMessage='You can only mark if one of the conditions is met:'
                />
              </div>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForToddlers.text.2'
                  defaultMessage={'You\'re a married man.'}
                />
              </div>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForToddlers.text.3'
                  defaultMessage={'You are not married and section 7 above has not been marked'}
                />
              </div>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForToddlers.text.4'
                  defaultMessage='You are a woman, unmarried and one or more of your children.'
                />
              </div>
              <FieldSelect
                fieldId='forToddlersBornCount'
                loadOptions={childrenOpts}
                label={(
                  <FormattedMessage
                    id='step13.form.isForToddlers.toddlersBorn.label'
                    defaultMessage={'Number of children born in the current tax year'}
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldSelect
                fieldId='forToddlersUpTo5Count'
                loadOptions={childrenOpts}
                label={(
                  <FormattedMessage
                    id='step13.form.isForToddlers.toddlersUpTo5yo.label'
                    defaultMessage={'The number of children who will be one to five years old this year'}
                  />
                )}
                containerStyles={styles.input}
              />
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'singleParentCustody'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isSingleParentCustody.label'
                  defaultMessage={'I am a single parent to my children in my custody'}
                />
              </div>
            )}
            containerStyles={values.singleParentCustody && styles.input}
          />
          {values.singleParentCustody && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isSingleParentCustody.text'
                  defaultMessage={'Single parent - a parent in a single-parent family who had a child in the tax year before the age of 19 and the other parent of the child died or the child is registered in the population register without the parent\'s details.'}
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'childAlimony'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isForChildrenNotInPossession.label'
                  defaultMessage={'I am a single parent to my children in my custody'}
                />
              </div>
            )}
            containerStyles={values.childAlimony && styles.input}
          />
          {values.childAlimony && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isForChildrenNotInPossession.text'
                  defaultMessage={'Will be filled in by a living employee separately, who is not entitled to credit points for his children, who invented a PSD requiring him to pay alimony.'}
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'disabledChild'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isParentOfIncapacitatedChild.label'
                  defaultMessage={'I am a parent of an incapacitated child who has not yet turned 19, for which I receive a disabled child benefit from the National Insurance Institute'}
                />
              </div>
            )}
            containerStyles={values.disabledChild && styles.input}
          />
          {values.disabledChild && (
            <>
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.isParentOfIncapacitatedChild.text'
                  defaultMessage='My spouse does not receive these credits. For my children I ask for the credit points, there is no income in the current year'
                />
              </div>
              <FieldFileUpload
                accept=".jpg, .jpeg, .png, .bmp"
                fieldId={'uploadApprovalOfDisabledChild'}
                label={(
                  <FormattedMessage
                    id='step13.form.isParentOfIncapacitatedChild.uploadApprovalOfDisabledChild.label'
                    defaultMessage='Approval of a disabled child benefit from the National Insurance Institute'
                  />
                )}
                cameraLabel={(
                  <FormattedMessage
                    id='common.form.uploadId.note'
                    defaultMessage='Take a photo or upload a file'
                  />
                )}
                containerStyles={styles.input}
              />
              <div className={styles.text}>
                <FormattedMessage
                  id='common.form.upload.unableToAttachFile.label'
                  defaultMessage='If you are unable to attach this file now, it will be possible to send it to us later'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'spouseAlimony'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.alimony.label'
                  defaultMessage={'In respect of alimony for an ex-spouse'}
                />
              </div>
            )}
            containerStyles={values.spouseAlimony && styles.input}
          />
          {values.spouseAlimony && (
            <>

              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.alimony.text.1'
                />
              </div>
              <FieldFileUpload
                accept=".jpg, .jpeg, .png, .bmp"
                fieldId={'uploadVerdict'}
                label={(
                  <FormattedMessage
                    id='step13.form.alimony.uploadVerdict.label'
                    defaultMessage='Please attach a verdict'
                  />
                )}
                cameraLabel={(
                  <FormattedMessage
                    id='common.form.uploadId.note'
                    defaultMessage='Take a photo or upload a file'
                  />
                )}
                containerStyles={styles.input}
              />
              <div className={styles.text}>
                <FormattedMessage
                  id='common.form.upload.unableToAttachFile.label'
                  defaultMessage='If you are unable to attach this file now, it will be possible to send it to us later'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'retiredSoldier'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isSoldierOrService.label'
                  defaultMessage={'I am a discharged soldier / national service'}
                />
              </div>
            )}
            containerStyles={values.retiredSoldier && styles.input}
          />
          {values.retiredSoldier && (
            <>
              <FieldDatepicker
                fieldId='retiredSoldierServiceStartDate'
                label={(
                  <FormattedMessage
                    id='step13.form.isSoldierOrService.from.label'
                    defaultMessage='Service start date'
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldDatepicker
                fieldId='retiredSoldierServiceEndDate'
                label={(
                  <FormattedMessage
                    id='step13.form.isSoldierOrService.to.label'
                    defaultMessage='Date of termination of service'
                  />
                )}
                containerStyles={styles.input}
              />
              <FieldFileUpload
                accept=".jpg, .jpeg, .png, .bmp"
                fieldId={'uploadCertificateOfRelease'}
                label={(
                  <FormattedMessage
                    id='step13.form.isSoldierOrService.uploadCertificateOfRelease.label'
                    defaultMessage='Please attach a photocopy of the certificate of release / termination of service'
                  />
                )}
                cameraLabel={(
                  <FormattedMessage
                    id='common.form.uploadId.note'
                    defaultMessage='Take a photo or upload a file'
                  />
                )}
                containerStyles={styles.input}
              />
              <div className={styles.text}>
                <FormattedMessage
                  id='common.form.upload.unableToAttachFile.label'
                  defaultMessage='If you are unable to attach this file now, it will be possible to send it to us later'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'graduation'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.graduation.label'
                  defaultMessage={'In respect of graduation for an academic degree, completion of an internship or completion of vocational studies'}
                />
              </div>
            )}
            containerStyles={values.graduation && styles.input}
          />
          {values.graduation && (
            <>
              <FieldFileUpload
                accept=".jpg, .jpeg, .png, .bmp"
                fieldId={'uploadStatementF119'}
                label={(
                  <FormattedMessage
                    id='step13.form.graduation.uploadStatementF119.label'
                    defaultMessage='Please attach a statement in Form 119'
                  />
                )}
                cameraLabel={(
                  <FormattedMessage
                    id='common.form.uploadId.note'
                    defaultMessage='Take a photo or upload a file'
                  />
                )}
                containerStyles={styles.input}
              />
              <div className={`${styles.text} ${styles.input}`}>
                <FormattedMessage
                  id='step13.form.graduation.note'
                  defaultMessage='You can use the computerized Form 119 or download the form from the Tax Authority website.'
                />
              </div>
              <div className={styles.text}>
                <FormattedMessage
                  id='common.form.upload.unableToAttachFile.label'
                  defaultMessage='If you are unable to attach this file now, it will be possible to send it to us later'
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.contentBlock}>
          <FieldCheckbox
            fieldId={'under18'}
            label={(
              <div className={styles.text}>
                <FormattedMessage
                  id='step13.form.isUnder18yo.label'
                  defaultMessage='I have not yet turned 18 years old'
                />
              </div>
            )}
          />
        </div>

      </div>

      <div className={styles.innerPadding}>
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
        />
      </div>
      {!isValid && <ErrorValidation/>}
    </Form>
  )
};

Step13View.propTypes = {
  values: PropTypes.object,
  isValid: PropTypes.bool,
  loadOptions: PropTypes.shape({
    immigrant: PropTypes.func,
    childrenOpts: PropTypes.func
  })
};

export default Step13View;
